import axios from 'axios';

export const moduleNewsList = {
	state() {
		return {
			newsList: null,
		};
	},
	mutations: {
		setNewsList(state, data) {
			state.newsList = data;
		},
	},
	getters: {
		getNewsList: (state) => state.newsList,
	},
	actions: {
		fetchNewsList({ commit, dispatch }) {
			const skip = 0,
				take = 3;

			dispatch('newLogoutTime');
			axios
				.get('MNews/List?skip=' + skip + '&take=' + take)
				.then((response) => {
					commit('setNewsList', response.data);
				})
				.catch(() => {});
		},
	},
};
